<template>
  <div class="c-formbuilder-row">
    <div v-if="localElem.type == 'base-heading'">
      <base-heading :type="localElem.properties.type" :text="localElem.properties.text" />
    </div>
    <div v-if="localElem.type == 'text-block'">
      <text-block v-html="localElem.content" />
    </div>
    <div v-if="localElem.type == 'form-textfield'">
      <form-textfield
        tabindex="0"
        v-bind="localElem.properties"
        :name="localElem.properties.label"
        @input="updateValue"
        v-model="localVal"
      />
    </div>
    <div v-if="localElem.type == 'form-select'">
      <form-select
        tabindex="0"
        v-bind="localElem.properties"
        :name="localElem.properties.label"
        @input="updateValue"
      />
    </div>
    <div v-if="localElem.type == 'form-dateinput'">
      <form-dateinput
        tabindex="0"
        v-bind="localElem.properties"
        :name="localElem.properties.label"
        @input="updateValue"
      />
    </div>
    <div v-if="localElem.type == 'form-textarea'">
      <form-textarea v-bind="localElem.properties" :tabindex="0" v-model="localVal" />
    </div>
    <div v-if="localElem.type == 'form-checkbox'">
      <form-checkbox
        v-bind="localElem.properties"
        :name="localElem.properties.label"
        tabindex="0"
        @input="updateValue"
      />
    </div>
    <div v-if="localElem.type == 'form-radio'">
      <form-radio
        tabindex="0"
        v-bind="localElem.properties"
        :name="localElem.properties.label"
        @input="updateValue"
      />
    </div>
    <div v-else-if="['media-file-upload','media-file'].includes(localElem.type)" class="col-xs-12 bordered">
        <media-file-upload
          v-bind="localElem.properties"
          :name="localElem.properties.title"
        @input="updateValue"
        />
      </div>
  </div>
</template>

<script>
export default {
  name: "FormBuilderColumn",
  props: {
    element: {
      type: String,
      default: null
    },
    id: {
      type: [String, Number]
    }
  },
  data() {
    return {
      localElem: null,
      value: null
    };
  },
  methods: {
    updateValue(val) {
      this.$emit("input", val);
    },
    onKeyUp(ev, el) {
      this.localVal = ev;
    },
    handleRadio(e, label, id) {
      
    }
  },
  created() {
    this.localElem = JSON.parse(this.element);
  },
  computed: {
    localVal: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit("input", newVal);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>